import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { Menu, X } from "lucide-react";
import { useState } from "react";
import CountdownBar from "@/components/CountdownBar";

const links = [
  { id: "hero", label: "الرئيسية" },
  { id: "activities", label: "الأنشطة" },
  { id: "journey", label: "رحلة الطفل" },
  { id: "location", label: "الموقع" },
  { id: "sponsors", label: "الرعاة" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const { scrollY } = useScroll();
  const bg = useTransform(scrollY, [0, 100], ["rgba(255,253,240,0)", "rgba(255,253,240,0.85)"]);
  const border = useTransform(scrollY, [0, 100], ["rgba(255,214,0,0)", "rgba(255,214,0,0.6)"]);

  const jump = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <motion.header
      ref={ref}
      style={{ backgroundColor: bg, borderBottomColor: border }}
      className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl border-b transition-colors"
      data-testid="site-header"
    >
      {/* Mobile-only opaque backdrop (framer-motion inline bg is transparent at scrollY=0, would leak content on small screens) */}
      <div aria-hidden className="absolute inset-0 bg-[#FFFDF0]/95 sm:hidden pointer-events-none" />
      <div className="relative">
      <CountdownBar />
      <div className="container-x flex items-center justify-between py-2 sm:py-3">
        <button onClick={() => jump("hero")} className="flex items-center gap-2 min-w-0" data-testid="header-brand">
          <img src="/assets/logo.jpeg" alt="Logo" className="h-9 w-9 sm:h-11 sm:w-11 object-contain rounded-xl flex-shrink-0" />
          <div className="hidden sm:block leading-tight text-right min-w-0">
            <div className="font-display font-black text-xs sm:text-sm text-[#0066CC] truncate">مهرجان العودة للمدارس</div>
            <div className="text-xs text-[#475569] font-semibold">Back to School • ليبيا</div>
          </div>
        </button>

        <nav className="hidden md:flex items-center gap-1" data-testid="header-nav">
          {links.map((l) => (
            <button
              key={l.id}
              onClick={() => jump(l.id)}
              className="px-4 py-2 rounded-full text-sm font-bold text-[#1E293B] hover:bg-[#FFD600]/40 transition-colors"
              data-testid={`nav-${l.id}`}
            >
              {l.label}
            </button>
          ))}
          <button
            onClick={() => jump("register")}
            className="mr-2 px-5 py-2 rounded-full text-sm font-black text-white bg-[#0066CC] hover:bg-[#004a99] transition-colors shadow-md"
            data-testid="nav-register-cta"
          >
            سجّل الآن
          </button>
        </nav>

        <button
          className="md:hidden p-2 rounded-full bg-[#FFD600]"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
          data-testid="header-mobile-toggle"
        >
          {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </div>

      {open && (
        <motion.div
          initial={{ opacity: 0, y: -6 }}
          animate={{ opacity: 1, y: 0 }}
          className="md:hidden bg-white/95 backdrop-blur-lg border-t border-yellow-200"
          data-testid="header-mobile-menu"
        >
          <div className="container-x py-3 flex flex-col gap-1">
            {links.map((l) => (
              <button
                key={l.id}
                onClick={() => jump(l.id)}
                className="text-right px-3 py-2 rounded-lg font-bold hover:bg-[#FFD600]/40"
              >
                {l.label}
              </button>
            ))}
            <button onClick={() => jump("register")} className="text-right px-3 py-2 rounded-lg font-black text-white bg-[#0066CC]">
              سجّل الآن
            </button>
          </div>
        </motion.div>
      )}
      </div>
    </motion.header>
  );
}
